module.exports = __webpack_public_path__ + "img/testtimewarning.ad74c50d.svg";